import React from 'react';

import GraphicSectionMidsize from "./Sections/GraphicSectionMidsize";

function Solutions() {
  let data = [
    {
      key: "SecuritySolutionSecuDocu",
      bgImagePath: "/images/GraphicSection_server_one_mod.jpeg",
      bgImageOffset: "0% 6%",
      subTitle: "Security Solution",
      mainTitle: "SecuDocu",
      keyWord: "Printed Data Loss Prevention",
      alignRight: false,
      textShadow: false,
    },
    {
      key: "EpsonCR",
      bgImagePath: "/images/GraphicSection_projector_mod.jpeg",
      bgImageOffset: "0% 30%",
      subTitle: "EPSON CR",
      mainTitle: "Projector and Smart Glasses",
      keyWord: "Exceptional quality and High productivity",
    },
    {
      key: "ArSolution",
      bgImagePath: "/images/GraphicSection_ar_mod.jpeg",
      bgImageOffset: "0% 20%",
      subTitle: "AR Solution",
      mainTitle: "Smart Factory",
      keyWord: "Industrial Augmented Reality",
      textShadow: true,
      alignRight: true,
    },
    {
      key: "ITInfraSolution",
      bgImagePath: "/images/GraphicSection_server_two_mod.jpeg",
      bgImageOffset: "0% 85%",
      subTitle: "IT Infra Solution",
      mainTitle: "ORACLE Services",
      keyWord: "Highly automated and secure",
      textShadow: true,
      alignRight: true,
    },
    {
      key: "HealthcareSolution",
      bgImagePath: "/images/GraphicSection_healthcare_mod.jpeg",
      bgImageOffset: "0% 20%",
      subTitle: "Healthcare Solution",
      mainTitle: "CarePatch",
      keyWord: "Measure Body Temperature for 24 Hours",
      textShadow: true,
    },
    {
      key: "SecuritySolutionFireEye",
      bgImagePath: "/images/GraphicSection_server_one.jpeg",
      bgImageOffset: "0% 20%",
      subTitle: "Security Solution",
      mainTitle: "FireEye",
      keyWord: "Centralize security operations with one platform",
    },
  ];
  let MidSections = data.map((value,index,array) => {
    let hide = value.hide;
    if(!hide) return <GraphicSectionMidsize key={value.key} info={value}/>;
  });
  return (
    <div className="Solutions" style={{paddingTop:'56px'}}>
      {MidSections}
    </div>
  );
}

export default Solutions;
